import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const [form, setForm] = useState({
    email: "",
    password: "",
    name: "",
    organization: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Registrazione completata ✦");
      nav("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-28 min-h-screen">
      <div className="max-w-md mx-auto px-4">
        <span className="av-eyebrow">Registrazione</span>
        <h1 className="font-serif-display text-4xl mt-3">
          Crea il tuo <span className="italic text-[#E5A93C]">accesso</span>
        </h1>
        <form onSubmit={submit} className="av-card p-6 mt-8 space-y-4" data-testid="register-form">
          <div>
            <label className="av-label">Nome referente *</label>
            <input
              required
              className="av-input"
              value={form.name}
              onChange={upd("name")}
              data-testid="reg-name-input"
            />
          </div>
          <div>
            <label className="av-label">Email *</label>
            <input
              type="email"
              required
              className="av-input"
              value={form.email}
              onChange={upd("email")}
              data-testid="reg-email-input"
            />
          </div>
          <div>
            <label className="av-label">Password (min 6) *</label>
            <input
              type="password"
              required
              minLength={6}
              className="av-input"
              value={form.password}
              onChange={upd("password")}
              data-testid="reg-password-input"
            />
          </div>
          <div>
            <label className="av-label">Ente / Organizzazione</label>
            <input
              className="av-input"
              value={form.organization}
              onChange={upd("organization")}
              data-testid="reg-org-input"
            />
          </div>
          <div>
            <label className="av-label">Telefono</label>
            <input
              className="av-input"
              value={form.phone}
              onChange={upd("phone")}
              data-testid="reg-phone-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="av-pill av-pill-gold w-full justify-center"
            data-testid="register-submit-btn"
          >
            {loading ? "Attendi…" : "Crea account"}
          </button>
          <p className="text-sm text-[#A39E93] text-center">
            Hai già un account?{" "}
            <Link to="/login" className="text-[#E5A93C]" data-testid="go-login-link">
              Accedi
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
